import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import emailjs from 'emailjs-com';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    industry: '',
    dataType: '',
    predictionGoal: '',
    dataVolume: '',
    dataSources: '',
    currentChallenges: '',
    timeframe: '',
    additionalContext: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send email using EmailJS
    emailjs.send('service_o39arbh', 'template_hvtyd4o', formData, '5YBmQVHgM84wgJ4vw')
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        alert('Your message has been sent successfully!');
      }, (error) => {
        console.log('FAILED...', error);
        alert('Failed to send your message. Please try again later.');
      });
  };

  return (
    <div> 
      {/* Navigation */}
      <nav className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-blue-600">PredictFlow</a>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" class="text-gray-700 hover:text-blue-600">Return to Home</Link>
            </div>
          </div>
        </div>
      </nav>

    <div className="bg-white py-16">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-blue-600">
          Machine Learning Project Inquiry
        </h2>
        <form onSubmit={handleSubmit} className="bg-gray-50 p-8 rounded-lg shadow-md">
          <div className="grid md:grid-cols-2 gap-6">
            <div className="mb-4">
              <label htmlFor="name" className="block text-gray-700 font-semibold mb-2">
                Full Name
              </label>
              <input 
                type="text" 
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Your full name"
              />
            </div>
            
            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-700 font-semibold mb-2">
                Work Email
              </label>
              <input 
                type="email" 
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Work email address"
              />
            </div>
            
            <div className="mb-4">
              <label htmlFor="company" className="block text-gray-700 font-semibold mb-2">
                Company
              </label>
              <input 
                type="text" 
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Your company name"
              />
            </div>

            <div className="mb-4">
              <label htmlFor="industry" className="block text-gray-700 font-semibold mb-2">
                Industry
              </label>
              <select
                id="industry"
                name="industry"
                value={formData.industry}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Industry</option>
                <option value="finance">Finance</option>
                <option value="healthcare">Healthcare</option>
                <option value="retail">Retail</option>
                <option value="manufacturing">Manufacturing</option>
                <option value="technology">Technology</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="mb-4">
              <label htmlFor="dataType" className="block text-gray-700 font-semibold mb-2">
                Type of Data
              </label>
              <select
                id="dataType"
                name="dataType"
                value={formData.dataType}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Data Type</option>
                <option value="timeSeries">Time Series</option>
                <option value="tabular">Tabular</option>
                <option value="text">Text</option>
                <option value="image">Image</option>
                <option value="mixed">Mixed</option>
              </select>
            </div>

            <div className="mb-4">
              <label htmlFor="predictionGoal" className="block text-gray-700 font-semibold mb-2">
                Prediction Goal
              </label>
              <input 
                type="text" 
                id="predictionGoal"
                name="predictionGoal"
                value={formData.predictionGoal}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="What do you want to predict?"
              />
            </div>

            <div className="mb-4">
              <label htmlFor="dataVolume" className="block text-gray-700 font-semibold mb-2">
                Approximate Data Volume
              </label>
              <select
                id="dataVolume"
                name="dataVolume"
                value={formData.dataVolume}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Data Volume</option>
                <option value="small">Less than 1GB</option>
                <option value="medium">1GB - 100GB</option>
                <option value="large">100GB - 1TB</option>
                <option value="xlarge">More than 1TB</option>
              </select>
            </div>
          </div>

          <div className="mb-4">
            <label htmlFor="dataSources" className="block text-gray-700 font-semibold mb-2">
              Data Sources
            </label>
            <input 
              type="text" 
              id="dataSources"
              name="dataSources"
              value={formData.dataSources}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="List your primary data sources (e.g., CRM, ERP, Sensors)"
            />
          </div>

          <div className="mb-4">
            <label htmlFor="currentChallenges" className="block text-gray-700 font-semibold mb-2">
              Current Predictive Challenges
            </label>
            <textarea 
              id="currentChallenges"
              name="currentChallenges"
              value={formData.currentChallenges}
              onChange={handleChange}
              rows={4}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe the specific predictive challenges you're facing"
            ></textarea>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="mb-4">
              <label htmlFor="timeframe" className="block text-gray-700 font-semibold mb-2">
                Project Timeframe
              </label>
              <select
                id="timeframe"
                name="timeframe"
                value={formData.timeframe}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Timeframe</option>
                <option value="urgent">Urgent (1-2 months)</option>
                <option value="medium">Medium (3-6 months)</option>
                <option value="longTerm">Long-term (6+ months)</option>
              </select>
            </div>

            <div className="mb-4">
              <label htmlFor="additionalContext" className="block text-gray-700 font-semibold mb-2">
                Additional Context
              </label>
              <input 
                type="text" 
                id="additionalContext"
                name="additionalContext"
                value={formData.additionalContext}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Any other relevant information"
              />
            </div>
          </div>
          
          <button 
            type="submit" 
            className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition duration-300 mt-4"
          >
            Submit Project Inquiry
          </button>
        </form>
      </div>
    </div>
    </div>
  );
};

export default ContactForm;